var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQrActivo = function SvgQrActivo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "qr_activo_svg__Capa_2",
    viewBox: "0 0 13.64 13.41"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "qr_activo_svg__Capa_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.68 0C5.49.49 7.9 1.69 9.9 3.69c1.66 1.66 2.78 3.64 3.37 5.91.21.81.34 1.64.38 2.48.03.52-.19.92-.65 1.16-.44.22-.87.17-1.26-.13-.26-.2-.41-.48-.43-.82-.12-2.16-.82-4.12-2.13-5.85A10.5 10.5 0 0 0 5.3 3.27c-.95-.45-1.94-.74-2.98-.91-.51-.08-.9-.48-.97-.98-.07-.52.21-1.04.68-1.23.2-.08.43-.1.65-.15",
    fill: "#aaeee8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.94 11.92c-.04.71-.51 1.18-1.11 1.21a1.17 1.17 0 0 1-1.23-1.01c-.09-.6-.23-1.19-.49-1.74-.68-1.45-1.76-2.48-3.26-3.06-.26-.1-.54-.18-.81-.24-.52-.13-.9-.57-.93-1.08-.03-.53.29-1.01.8-1.19.29-.1.58-.04.87.04a8.2 8.2 0 0 1 3.76 2.11c1.22 1.21 1.99 2.65 2.3 4.34.05.25.08.5.09.63Z",
    fill: "#7fe6dd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.73 13.4c-.99-.04-1.76-.89-1.73-1.89.04-1 .89-1.77 1.9-1.73 1 .04 1.78.9 1.72 1.9-.05 1-.9 1.76-1.89 1.72",
    fill: "#2ad2c5"
  }))));
};
export default SvgQrActivo;